import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AutocompleteInput from "../../../../../global/Autocomplete/AutocompleteInput";
import { addEditUrls, getUrls } from "../../../../../services/api.enums";
import { addEditDataAPI, getAPI } from "../../../../../services/CRUDServices";
import SimpleButton from "../../../../../global/SimpleButton/SimpleButton";
import { setOrder } from "../../../../../redux/OrderData/OrderData";
import HubElements from "../Elements/HubElements";

const BoxiAddresses = ({ CloseModal, setFieldValue }: any) => {
  const [Boxies, setBoxies] = useState([]);
  const [Boxi, setBoxi] = useState<any>();
  const [Search, setSearch] = useState("");
  const { orderData } = useSelector((state: any) => state.Order);
  const { currenthub } = useSelector((state: any) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    getAPI(
      `${getUrls.hubLocation}${Search}&cityid=${orderData.fromCountryDevisionId}`
    ).then((res) => setBoxies(res.data.payload));
  }, [Search, orderData.fromCountryDevisionId]);

  const handleSelectHub = () => {
    if (Boxi) {
      const readyData = {
        returnHubId: Boxi.id,
        returnHubName: Boxi.name,
        returnHubAddress: Boxi.addressLine,
        returnAddressId: null,
        returnAddressName: null,
        returnAddressTitle: null,
        returnAddressPostalCode: null,
        returnAddressDetail: null,
        returnLat: null,
        returnLng: null,
      };

      if (orderData?.orderId) {
        addEditDataAPI(addEditUrls.submitFirstProccess, "put", {
          ...orderData,
          ...readyData,
          originHubId: orderData.pickupHubId,
          selectCurrentHub: currenthub,
        })
          .then(() => {
            dispatch(setOrder(readyData));
            CloseModal();
            setBoxi(undefined);
          })
          .catch(() => toast.error("مشکلی از سمت سرور رخ داده است"));
      } else {
        dispatch(setOrder(readyData));
        CloseModal();
        setBoxi(undefined);
      }
    } else {
      toast.error("لطفا مرکز باکسیت را انتخاب کنید");
    }
  };

  const handleClick = (item: any) => {
    setBoxi(item);
    setFieldValue("lng", item.locLong);
    setFieldValue("lat", item.locLate);
    setFieldValue("address", item.address);
  };

  return (
    <div className="w-full sm:w-96 min-h-[35rem]">
      <p className="text-dark mb-4">مراکز مجاز باکسیت</p>
      <AutocompleteInput
        value={Search}
        onChange={(e) => setSearch(e.target.value)}
        wrapperClassName="w-full"
        placeholder="جستجو مرکز"
      />
      {Boxies.length > 0 ? (
        <div className="flex flex-col gap-3 max-h-[25rem] overflow-auto">
          {Boxies.map((item: any) => (
            <HubElements item={item} Boxi={Boxi} handleClick={handleClick} />
          ))}
        </div>
      ) : (
        "هابی برای این شهر ثبت نشده است"
      )}
      <div className="btnForm">
        <SimpleButton
          handelClick={CloseModal}
          text="لغو"
          className="full-lightTomato-btn w-full"
        />
        <SimpleButton
          handelClick={handleSelectHub}
          text="تایید"
          className="full-tomato-btn w-full"
        />
      </div>
    </div>
  );
};

export default BoxiAddresses;
